import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCancelOrderList, saveCancelOrderList, getCancelOrderReasonList } from '../../actions/cancelOrder';
import { Link, withRouter } from 'react-router-dom';
import MobileView from '../common/mobileView'
import FullPageLoader from '../../components/common/fullPageLoader'
import { Helmet } from 'react-helmet'
import Success from "./success-page"
import { toast } from 'react-toastify';

class cancelOrder extends Component{
    constructor(){
        super()
        this.state = {
            cancelCheckbox : [],
            returnOrderFilterList:[],
            returnCheckbox:[],
            returnSelect:[],
            returnOrderProduct : [],
        }
    }
    componentDidMount = () => {
        const { connection_id, userDetails, getCancelOrderList, getCancelOrderReasonList } = this.props;
        getCancelOrderList(connection_id, userDetails.COM_CONSUMER_MOBILE_NO)
        getCancelOrderReasonList(connection_id, 'OC')
    }

    // handleSelectReason = () => {

    // }

    // 
    //  = (e, item, index) => {
    //     if(e.target.checked){
    //         // let newValue = {RID_ITEM_PRICE: item.RID_ITEM_PRICE , RID_PRICE: item.RID_PRICE ,  SKU_SIZE:item.SKU_SIZE, RID_SELLING_PRICE: item.RID_SELLING_PRICE , RIH_CART_AMT:item.RIH_CART_AMT ,  RIH_CART_CREATE_DATE: item.RIH_CART_CREATE_DATE , RPD_ITEM_STATUS_CD:item.RPD_ITEM_STATUS_CD , RPD_ITEM_STATUS_DESC: item.RPD_ITEM_STATUS_DESC , RPD_LOT_CD: item.RPD_LOT_CD , RPD_ORDER_QTY: item.RPD_ORDER_QTY , RPD_PRINCIPAL_ORDER_NO: item.RPD_PRINCIPAL_ORDER_NO , SKU_DESC: item.SKU_DESC , SKU_IMAGE: item.SKU_IMAGE, SKU_CD: item.SKU_CD, SKU_COLOUR:item.SKU_COLOUR}
    //         this.setState({ cancelCheckbox : this.state.cancelCheckbox.concat([item]) })
    //     }else{
    //         let checkboxValue = this.state.cancelCheckbox.filter(function(val) {return val.RPD_PRINCIPAL_ORDER_NO !== item.RPD_PRINCIPAL_ORDER_NO})
    //         this.setState({ cancelCheckbox: checkboxValue })
    //         this['myReasonList'+index].value = '';
    //     }
    // }


     // Select Reason

     handleSelectReason = (event, value, index) => {
        const returnReasonValue = event.target.value;
        if(returnReasonValue !== ''){
            // Validation
            let returnSelectValue =  this.state.returnSelect.filter(function(val) {return val === index})
            if( returnSelectValue.length === 0 ){
                this.setState({ returnSelect : this.state.returnSelect.concat([index]) })
            }
            // End Validation

            let newSeletedReason = this.props.cancelOrderReasonList.filter(function(val) { return val.RSD_REASON_CD === returnReasonValue})


            // Select Product

            let newReason = {order_no: value.RIH_PRINCIPAL_ORDER_NO,order_associate_code: value.RIH_PRINCIPAL_ORDER_ASSOC_CD,invoice_no: value.rih_invno,invoice_assoc_code: value.rih_assoc_cd,invoice_date: value.rih_inv_dt,lot_code: value.RID_LOT_CD,sl_no: value.RID_SLNO,sku_code: value.RID_SKU_CD,return_qty: value.RID_RETURN_QTY,return_reason:returnReasonValue, cancel_reason_cd: newSeletedReason[0].RSD_REASON_CD, cancel_reason_desc: newSeletedReason[0].RSD_REASON_NAME}
            const countSelectedReason =  this.state.returnOrderFilterList.filter(function(val) {return val.lot_code === value.RID_LOT_CD})
            // let newValue = value.concat({cancel_reason_cd: newSeletedReason[0].RSD_REASON_CD, cancel_reason_desc: newSeletedReason[0].RSD_REASON_NAME})
            
            let newValue = value
            newValue.cancel_reason_cd = newSeletedReason[0].RSD_REASON_CD;
            newValue.cancel_reason_desc = newSeletedReason[0].RSD_REASON_NAME;
            
            if(countSelectedReason.length === 0){
               this.setState({ 
                   returnOrderFilterList: this.state.returnOrderFilterList.concat([newReason]),
                   returnOrderProduct : this.state.returnOrderProduct.concat([newValue])
                })
            }
            else{
               const oldSelectedValue =  this.state.returnOrderFilterList.filter(function(val) {return val.lot_code !== value.RID_LOT_CD})
               const oldSelectedProduct =  this.state.returnOrderProduct.filter(function(val) {return val.RID_LOT_CD !== value.RID_LOT_CD})
               this.setState({ 
                    returnOrderFilterList: oldSelectedValue.concat([newReason]),
                    returnOrderProduct: oldSelectedProduct.concat([newValue])
             })
            }
        }
        else{
            // Validation
            let returnSelectValue =  this.state.returnSelect.filter(function(val) {return val !== index})
                this.setState({ returnSelect : returnSelectValue })
             
            // Select Product
            const oldSelectedValue =  this.state.returnOrderFilterList.filter(function(val) {return val.lot_code !== value.RID_LOT_CD})
            const oldSelectedProduct =  this.state.returnOrderProduct.filter(function(val) {return val.RID_LOT_CD !== value.RID_LOT_CD})
                this.setState({ returnOrderFilterList: oldSelectedValue, returnOrderProduct: oldSelectedProduct})
        } 
    }

    // CheckBox the Reason

    selectCancelOrder = (e, value, index) => {
        if(e.target.checked){
            this.setState({ returnCheckbox : this.state.returnCheckbox.concat([index]) })
        }
        else{
            let returnCheckboxtValue =  this.state.returnCheckbox.filter(function(val) {return val !== index})
            let returnSelectValue =  this.state.returnSelect.filter(function(val) {return val !== index})
            const oldSelectedValue =  this.state.returnOrderFilterList.filter(function(val) {return val.lot_code !== value.RID_LOT_CD})
            const oldSelectedProduct =  this.state.returnOrderProduct.filter(function(val) {return val.RID_LOT_CD !== value.RID_LOT_CD})
            this.setState({ returnCheckbox : returnCheckboxtValue, returnSelect : returnSelectValue, returnOrderFilterList: oldSelectedValue, returnOrderProduct: oldSelectedProduct })
            this['myReasonList'+index].value = '';
        }
    }


    cancelSelectedOrder = (event) => {
        event.preventDefault();
        const { saveCancelOrderList, connection_id, userDetails } = this.props;
        const { returnOrderProduct } = this.state;

        const products = returnOrderProduct.map((reason, i) => {
            return { 
                "barcode": reason.RPD_LOT_CD,
                "sku_code": reason.SKU_CD,
                "cancel_order_qty": reason.RPD_ORDER_QTY,
                "cancel_reason_cd": reason.cancel_reason_cd,
                "cancel_reason_desc": reason.cancel_reason_desc
                }
            }
           )
        
        if(this.state.returnOrderFilterList.length !== 0 || this.state.returnCheckbox.length !== 0){
            if(JSON.stringify(this.state.returnSelect) === JSON.stringify(this.state.returnCheckbox)){
            const options = {
                "orders": [
                    {
                        "order_no": returnOrderProduct[0].RPD_PRINCIPAL_ORDER_NO,
                        "order_type": "CO",
                        "order_assoc_code": userDetails.COM_ASSOC_CD,
                        "order_assoc_name": userDetails.COM_ASSOC_NAME,
                        "cancellation_reference_no": userDetails.COM_ASSOC_CD,
                        "consumer_mobile_no": userDetails.COM_CONSUMER_MOBILE_NO,
                        "consumer_name": userDetails.COM_FNAME,
                        "products": products
                    }
                ]
            }
    
                saveCancelOrderList(connection_id, options)

            }
            else if(this.state.returnSelect.length < this.state.returnCheckbox.length){
                toast.error("Please select a Product Reason to proceed with Cancel.")
            }
            else if(this.state.returnSelect.length > this.state.returnCheckbox.length){
                toast.error("Please select Checkbox")
            }
        }
        else{
            toast.error("Please select a Product to proceed with Cancel Order.")
        }
        
       
    }

    

    render(){
        const { cancelOrderItem, symbol, loading, success, cancelOrderReasonList } = this.props;

        if (!!success) {
            return <>
                <Success {...this.props} />
            </>
        }

        if (loading) return <div><FullPageLoader /></div>
        return(
            <React.Fragment>
                 {/*SEO Support*/}
                 <Helmet>
                <title>{this.props.customer_name} | Cancel Orders</title>
                </Helmet>
                {/*SEO Support End */}

                {cancelOrderItem.length > 0 ?
                    <section className="cart-section section-b-space">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                <div className="mini-title">
                                        <span>Cancel Orders</span>
                                    </div>
                                    <div className="mini-title-divider"></div>
                                     {/* Mobile Titlw Section */}
                                     <div className="mobile-title">
                                        <span>Cancel Order</span>
                                    </div>
                                    <div className="mobile-divider"></div>
                                    {/* Mobile Titlw Section Ends*/}
                                    <table className="table cart-table table-responsive-xs">
                                        <thead>
                                            <tr className="table-head">
                                                <th scope="col">image</th>
                                                <th scope="col">product name</th>
                                                <th scope="col">price</th>
                                                <th scope="col">quantity</th>
                                                <th scope="col">size</th>
                                                <th scope="col">order No</th>
                                                <th scope="col">order date</th>
                                                <th scope="col">Status</th>
                                                <th scope="col">Eligible</th>
                                            </tr>
                                        </thead>
                                        {cancelOrderItem.sort((a,b) => new Date(b.RIH_CART_CREATE_DATE) - new Date(a.RIH_CART_CREATE_DATE)).map((item, index) => {
                                            return (
                                                <tbody key={index}>
                                                    <tr>
                                                        <td>
                                                            <Link to={`${process.env.PUBLIC_URL}/PD/${item.RPD_LOT_CD}`}>
                                                                <img src={item.SKU_IMAGE} alt={item.SKU_IMAGE} />
                                                            </Link>
                                                        </td>
                                                        <td><Link to={`${process.env.PUBLIC_URL}/PD/${item.RPD_LOT_CD}`} className="no-display-pls">{item.SKU_DESC}</Link>
                                                          
                                                            <MobileView 
                                                            view={'cancelOrder'}
                                                            data={item}
                                                            index={index}
                                                            functions={{
                                                                cancelOrder : this.selectCancelOrder
                                                            }}
                                                            />
                                                        </td>
                                                        <td className="no-display-pls"><h6>{symbol}{item.RID_ITEM_PRICE}</h6></td>
                                                        <td className="no-display-pls"><h6>{item.RPD_ORDER_QTY}</h6></td>
                                                        <td className="no-display-pls"><h6>{item.SKU_SIZE}</h6></td>
                                                        <td className="no-display-pls"><h6>{item.RPD_PRINCIPAL_ORDER_NO}</h6></td>
                                                        <td className="no-display-pls"><h6>{item.RIH_CART_CREATE_DATE}</h6></td>
                                                        <td className="no-display-pls"><h6>
                                                        <select className={"form-control"} ref={reasons => this['myReasonList'+index] = reasons} onChange={(e)=>this.handleSelectReason(e,item, index)} >
                                                            <option value="">Select Reason</option>
                                                            {cancelOrderReasonList && cancelOrderReasonList.map((reason, i) =>
                                                            <option key={i} value={reason.RSD_REASON_CD}>{reason.RSD_REASON_NAME}</option>
                                                               )}
                                                            </select>    
                                                        </h6></td>
                                                        <td className="no-display-pls">
                                                            <h6>
                                                            <input className="checkbox_animated" disabled={item.cancel_eligible_flag === 'Y' ? false : true} value={item.SKU_DESC} type="checkbox" onClick={(e) => this.selectCancelOrder(e,item, index)} />
                                                            </h6>
                                                        </td>
                                                    </tr>
                                                </tbody>)
                                        })}
                                    </table>
                                </div>
                            </div>
                            <div className="row cart-buttons">
                                <div className="col-12">
                                    <button className="btn btn-solid" onClick={(e) => this.cancelSelectedOrder(e)}>continue cancel</button>
                                </div>
                            </div>
                        </div>
                    </section>
                    :
                    <section className="cart-section section-b-space">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div >
                                        <div className="col-sm-12 empty-cart-cls text-center">
                                            <img src={`${process.env.PUBLIC_URL}/assets/images/icon-empty-cart.png`} className="img-fluid mb-4" alt="" />
                                            <h5>
                                                <strong>You do not have any Orders to view.</strong>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }
            </React.Fragment>
        )
    }
}

const mapStatetoProps = (state) => ({
    loading: state.cancelOrder.loading,
    cancelOrderReasonList: state.cancelOrder.cancelOrderReasonList,
    cancelOrderItem: state.cancelOrder.cancelOrderList,
    userDetails: state.user.user_details,
    symbol: state.data.symbol,
    customer_name: state.tenant.tenant_details.STE_ECOM_BRAND_NAME || "",
    success: state.cancelOrder.success,
})


export default connect(
    mapStatetoProps,
    { getCancelOrderList, saveCancelOrderList, getCancelOrderReasonList }
)(withRouter(cancelOrder))